import { CommunsModule } from './communs/communs.module';
import { VideoService } from './service/video.service';
import { FormsModule } from '@angular/forms';
import { PesquisaService } from './service/pesquisa.service';
import { FotosCampanhaService } from './service/fotos-campanha.service';
import { AngularFireStorage } from 'angularfire2/storage';
import { LinhadotempoService } from './service/linhadotempo.service';
import { BibliografiaService } from './service/bibliografia.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { FirebaseAuthService } from './_guard/firebase-auth-service';
import { AdminModule } from './admin/admin.module';
import { BlogService } from './service/blog.service';
import { ProjetoService } from './service/projeto.service';
import { SocialService } from './service/social.service';
import { BannerService } from './service/banner.service';
import { ConfiguracoesService } from './service/configuracoes.service';
import { PropostasService } from './service/propostas.service';
import { NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';


import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFirestore } from 'angularfire2/firestore';
import { FotosService } from './service/fotos.service';
import { EventoService } from './service/evento.service';
import { HtmlPipe } from './html.pipe';
import { ImgPipe } from './img.pipe';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PesquisaShowComponent } from './pesquisa-show/pesquisa-show.component';
import { AppRoutingModule } from './/app-routing.module';
import { HeroesModule } from './heroes/heroes.module';
import { PublicModule } from './/public.module';


registerLocaleData(localePt, 'pt');



@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule, BrowserAnimationsModule, HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule, RadioButtonModule, FormsModule, CommunsModule,
    AdminModule, ConfirmDialogModule, HeroesModule, PublicModule, AppRoutingModule
  ],
  providers: [AngularFirestore, AngularFireAuth, FirebaseAuthService, ConfirmationService, AngularFireStorage,
    ConfiguracoesService, PropostasService, BannerService, FotosService, LinhadotempoService, FotosCampanhaService,
    SocialService, ProjetoService, BlogService, EventoService, BibliografiaService, HttpClientModule, PesquisaService,
    VideoService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts